const columns = [
  {
    name: 'All WMRC RESPONSE Time',
    selector: (row) => row?.td_allWmrcTime,
  },
  {
    name: 'Selected WMRC RESPONSE Time',
    selector: (row) => row?.td_myWmrcTime,
  },
];
const mobileColumns = [
  {
    name: 'All WMRC RESPONSE Time',
    selector: (row) => row?.td_allWmrcTime,
  },
  {
    name: 'Selected WMRC RESPONSE Time',
    selector: (row) => row?.td_myWmrcTime,
  },
];

export { columns, mobileColumns };
